var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconbookblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.9993H5C4.53977 14.9993 4.16667 15.3724 4.16667 15.8327C4.16667 16.2929 4.53977 16.666 5 16.666H17.5V18.3327H5C3.61929 18.3327 2.5 17.2134 2.5 15.8327V3.33268C2.5 2.41221 3.24619 1.66602 4.16667 1.66602H17.5V14.9993ZM4.16667 13.3743C4.3013 13.347 4.44064 13.3327 4.58333 13.3327H15.8333V3.33268H4.16667V13.3743ZM13.3333 7.49935H6.66667V5.83268H13.3333V7.49935Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbookblue);
export default __webpack_public_path__ + "static/media/icon.book.blue.94da54c7e32596eba2534d457fa421b1.svg";
export { ForwardRef as ReactComponent };